<div ref="childrenContainer"></div>